import React from "react";
import { analyzeResume } from "./analyzerApi";
import type { AnalysisResult, AnalyzeInput } from "./analyzerTypes";

export function useAnalyzer() {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [result, setResult] = React.useState<AnalysisResult | null>(null);

  const analyze = async (input: AnalyzeInput) => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const data = await analyzeResume(input);
      setResult(data);
      return data;
    } catch (err: any) {
      const message = err?.message || "Analyze failed.";
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setResult(null);
    setError(null);
  };

  return {
    analyze,
    reset,
    loading,
    error,
    result,
  };
}